import React, { useState, useEffect } from "react";

//API
import { TemplateData, web_analytics_btn_clk } from "../store/api";
import { CollectionAuthentication } from "../store/api";

//Router
import { useLoaderData, useParams, Navigate } from "react-router-dom";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import PasswordDialog from "../components/shared/PasswordDialog";
import FallbackSocial from "../components/shared/FallbackSocial";
import LocationTracker from "../utils/LocationTracker";
import { ChooseCollectionTemplate } from "../utils/chooseTemplate";
import LoaderPage from "../components/loader/loader";

//Hooks
import {
  useContactUsFeature,
  useLeadFeature,
  useShareFeature,
} from "../utils/hooks";

import { emailTemplateInstanceID } from "../utils/constants";
import SessionTracker from "../utils/SessionTracker";
import { getCampaignData, getGeoLocation, getLocationData, getSessionId, getVisitorId } from "../utils/trackUtils";
import { updateAnalyticsBtnClkFlag, updateState } from "../store/slice/state";
// import SessionTracker from "../utils/SessionTracker";

export const CollectionRoutePath = () => {
  const loadedData = useLoaderData();
  const globalDispatch = useDispatch();
  console.log(loadedData, "collectionData");
  let { isLeadSent, collectionID, socialAnalyticsBtnClkFlag, contactUsAnalyticsBtnClkFlag, emailShareAnalyticsBtnClkFlag } = useSelector((state) => state.state);
  let sfdghfgdfgdfgdfg = useSelector((state) => state.state);
  console.log(sfdghfgdfgdfgdfg, "contactUsAnalyticsBtnClkFlagcontactUsAnalyticsBtnClkFlag");
  const { collectionURL } = useParams();

  const [isPasswordFalse, setIsPasswordFalse] = useState("");
  const [authPass, setAuthPass] = useState(true);
  const [visibility, setVisibility] = useState("");
  const [collectionData, setCollectionData] = useState(loadedData);
  const [trackState, setTrackState] = useState({
    visitorId: null,
    sessionId: null,
    geoLocation: null,
    campaignData: null,
  });
  const getBaseName = () => {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    return pathSegments.length > 0 ? `/${pathSegments[0]}` : "/";
  };


  // const PageLoader = () => {
  //   const [isLoading, setIsLoading] = React.useState(true);

  //   React.useEffect(() => {
  //     const timer = setTimeout(() => {
  //       setIsLoading(false);
  //     }, 1000); // Auto-hide after 3 seconds

  //     return () => clearTimeout(timer);
  //   }, []);

  //   if (!isLoading) return null;

  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100vh",
  //         backgroundColor: "#f4f4f4",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "50px",
  //           height: "50px",
  //           border: "5px solid rgba(0, 0, 0, 0.1)",
  //           borderTopColor: "#007bff",
  //           borderRadius: "50%",
  //           animation: "spin 1s linear infinite",
  //         }}
  //       ></div>
  //       <style>
  //         {`
  //           @keyframes spin {
  //             0% { transform: rotate(0deg); }
  //             100% { transform: rotate(360deg); }
  //           }
  //         `}
  //       </style>
  //     </div>
  //   );
  // };


  // useEffect(async() => {
  //   if (collectionData?.data?.visibility === "public") {
  //     setAuthPass(true);
  //   } else if (collectionData?.data?.visibility === "protected") {
  //     checkSessionStorageFn();
  //   } else if (collectionData?.data?.visibility === "private") {
  //     checkSessionStorageFn();
  //   }
  //   const visitorId = await getVisitorId();
  //   const sessionId = getSessionId();
  //   const geoLocation =await getGeoLocation();
  //   const campaignData = getCampaignData();
  //   setTrackState({
  //     visitorId,
  //     sessionId,
  //     geoLocation,
  //     campaignData,

  //   });
  //   setAccentColorsFn();
  // }, []);
  useEffect(() => {
    const initializeData = async () => {
      console.log();
      try {
        switch (collectionData?.data?.visibility) {
          case "public":
            setAuthPass(true);
            break;
          case "protected":
          case "private":
            checkSessionStorageFn();
            break;
          default:
            break;
        }

        switch (collectionData?.response?.data?.message) {
          case "Private access Email is required":
            setVisibility("private");
            setAuthPass(false);
            break;

          case "Invalid Email Access Denied":
            const alertDiv = document.createElement("div");
            alertDiv.style.position = "fixed";
            alertDiv.style.top = "10px";
            alertDiv.style.left = "10px";
            alertDiv.style.backgroundColor = "red";
            alertDiv.style.color = "white";
            alertDiv.style.padding = "10px";
            alertDiv.style.borderRadius = "5px";
            alertDiv.style.zIndex = "1000";
            alertDiv.innerText = "Invalid Email Access Denied";
            document.body.appendChild(alertDiv);

            setTimeout(() => {
              document.body.removeChild(alertDiv);
            }, 3000);
            setVisibility("private");
            setAuthPass(false);
            break;

          case "password is required":
            setVisibility("protected");
            setAuthPass(false);
            break;

            case "Invalid password":
              setVisibility("protected");
              const alertDivbox = document.createElement("div");
              alertDivbox.style.position = "fixed";
              alertDivbox.style.top = "10px";
              alertDivbox.style.left = "10px";
              alertDivbox.style.backgroundColor = "red";
              alertDivbox.style.color = "white";
              alertDivbox.style.padding = "10px";
              alertDivbox.style.borderRadius = "5px";
              alertDivbox.style.zIndex = "1000";
              alertDivbox.innerText = "Invalid Email Access Denied";
              document.body.appendChild(alertDivbox);
  
              setTimeout(() => {
                document.body.removeChild(alertDivbox);
              }, 3000);
              setAuthPass(false);
              break;

          default:
            setAuthPass(true);
            break;
        }
        const visitorId = await getVisitorId();
        const sessionId = getSessionId();
        const geoLocation = await getGeoLocation();
        const campaignData = getCampaignData();

        setTrackState({
          visitorId,
          sessionId,
          geoLocation,
          campaignData,
        });

        setAccentColorsFn();
      } catch (error) {
        console.error("Error initializing data:", error);
      }
    };

    initializeData();
  }, [collectionData]); // Dependency added if `collectionData` changes dynamically

  useEffect(() => {
    const button = document.getElementById("social_share_button");

    const handleAnalyticsClick = async () => {
      const visitorId = await getVisitorId();
      const sessionId = getSessionId();
      const trackingPayload = {
        "cid": collectionData?.data?.uid,
        "session_id": sessionId,
        "visitor_id": visitorId,
        "page_id": collectionURL,
        "page_url": window.location.href,
        "event_id": getBaseName() == "/guide" ? "25G04S" : "mp205ac",
        "event_name": "Social share clicked",
        "micropage_id": collectionData?.data.collectionID,
        "micropage_name": collectionData?.data.collectionTitle,
        "micropage_type": `${collectionData?.data.templateType}`,
        "campaign_id": null,
        "campaign_name": null
      }
      web_analytics_btn_clk(trackingPayload);
      // Dispatch the Redux action when the button is clicked
      globalDispatch(updateAnalyticsBtnClkFlag({ socialAnalyticsBtnClkFlag: false }));

    };

    if (button) {
      button.addEventListener("click", handleAnalyticsClick);
    }

    // Cleanup to remove the event listener
    return () => {
      if (button) {
        button.removeEventListener("click", handleAnalyticsClick);
      }
    };
  }, [socialAnalyticsBtnClkFlag]); // Dependency to avoid stale references

  useEffect(() => {
    const button = document.getElementById("email_share_button");

    const handleAnalyticsClick = () => {


      const trackingPayload = {
        "cid": collectionData?.data?.uid,
        "session_id": trackState.sessionId,
        "visitor_id": trackState.visitorId,
        "page_id": collectionURL,
        "page_url": window.location.href,
        "event_id": getBaseName() == "/guide" ? "G02M" : "mp205ac",
        "event_name": "email share clicked",
        "micropage_id": collectionData?.data.collectionID,
        "micropage_name": collectionData?.data.collectionTitle,
        "micropage_type": `${collectionData?.data.templateType}`,
        "campaign_id": null,
        "campaign_name": null
      }
      web_analytics_btn_clk(trackingPayload);
      // Dispatch the Redux action when the button is clicked
      globalDispatch(updateAnalyticsBtnClkFlag({ emailShareAnalyticsBtnClkFlag: false }));

    };

    if (button) {
      button.addEventListener("click", handleAnalyticsClick);
    }

    // Cleanup to remove the event listener
    return () => {
      if (button) {
        button.removeEventListener("click", handleAnalyticsClick);
      }
    };
  }, [emailShareAnalyticsBtnClkFlag]); // Dependency to avoid stale references

  useEffect(() => {
    const handleAnalyticsClick = async () => {
      const visitorId = await getVisitorId();
      const sessionId = getSessionId();
      const trackingPayload = {
        "cid": collectionData?.data?.uid,
        "session_id": trackState.sessionId,
        "visitor_id": trackState.visitorId,
        "page_id": collectionURL,
        "page_url": window.location.href,
        "event_id": getBaseName() == "/guide" ? "G01C" : "mp201cu",
        "event_name": "Contact Us clicked",
        "micropage_id": collectionData?.data.collectionID,
        "micropage_name": collectionData?.data.collectionTitle,
        "micropage_type": `${collectionData?.data.templateType}`, // Fixed template literal syntax
        "campaign_id": null,
        "campaign_name": null
      };

      web_analytics_btn_clk(trackingPayload);

      // Dispatch the Redux action to reset the flag after tracking
      globalDispatch(updateState({ contactUsAnalyticsBtnClkFlag: false }));
    };

    if (contactUsAnalyticsBtnClkFlag) {
      handleAnalyticsClick();
    }
  }, [contactUsAnalyticsBtnClkFlag]);


  const setAccentColorsFn = () => {
    const root = document.documentElement;
    root.style.setProperty(
      "--primary-color",
      collectionData?.data?.branding?.accentColors.primary
    );
    root.style.setProperty(
      "--bs-primary",
      collectionData?.data?.branding?.accentColors.primary
    );
    root.style.setProperty(
      "--bs-primary-rgb",
      collectionData?.data?.branding?.accentColors.primary
    );
    root.style.setProperty(
      "--secondary-color",
      collectionData?.data?.branding?.accentColors.secondary
    );
    if (collectionData?.data?.branding?.pageMetaTitle == null) {
      document.title = `${collectionData?.data?.branding?.collectionTitle}`;
    } else {
      document.title = `${collectionData?.data?.branding?.pageMetaTitle}`;
    }
  };
  // session storage only for type protected and private
  const checkSessionStorageFn = () => {
    let cID = sessionStorage.getItem("authVerify");

    //  cID=JSON.parse(cID)
    //console.log(cID, "sesionStorage");

    let parsedData = JSON.parse(cID);

    if (
      parsedData?.id === collectionData?.data?.collectionID &&
      parsedData?.pass === true
    ) {
      setAuthPass(true);
    } else {
      setAuthPass(false);
    }
  };

  // this if else is for deciding leadCapture form opening
  if (
    collectionID === collectionData?.data?.collectionID &&
    isLeadSent === true
  ) {
    isLeadSent = true;
  } else {
    isLeadSent = false;
  }

  const [features, setFeatures] = useState({
    isContactUsActive: false,
    isShareActive: false,
    isLeadActive: {
      from:
        isLeadSent === false &&
          collectionData?.data?.settings?.isLeadsCaptureFormEnabled === "Yes"
          ? "PAGE"
          : "AFTER-SHARE",
      value:
        isLeadSent === false &&
          collectionData?.data?.settings?.isLeadsCaptureFormEnabled === "Yes"
          ? true
          : false,
    },
    isSocialShareActive: true,
  });
  //console.log(collectionURL,'fe');
  const { ShareFeatureDesign } = useShareFeature({
    isActive: features?.isShareActive,
    changeState: setFeatures,
    uid: collectionData?.data?.uid,
    microId: collectionData?.data?.collectionID,
    emailConfig: {
      emailInstanceID: emailTemplateInstanceID?.COLLECTION,
      source_id: collectionURL,
      contentType: null,
      collectionURL: collectionURL,
    },
  });
  const { ContactUsFeatureDesign } = useContactUsFeature({
    uid: collectionData?.data?.uid,
    allData: collectionData?.data,
    changeState: setFeatures,
    isActive: features?.isContactUsActive,
  });
  const { LeadFeatureDesign } = useLeadFeature({
    exhibitorID: collectionData?.data?.uid,
    changeState: setFeatures,
    isActive: features?.isLeadActive?.value,
    collectionID: collectionData?.data?.collectionID,
  });
  const passwordSubmitFN = (e) => {
    let payload = {
      collection_unique_url: collectionURL,
    };

    if (visibility === "protected") {
      payload.protected_password = e; // Add password for protected collections
      window.protected_password = e; // Store the email in the global window object
    } else if (visibility === "private") {
      payload.private_mail = e; // Add email for private collections
      window.mail = e; // Store the email in the global window object
    }
    TemplateData(payload).then((data) => setCollectionData(data));
    // Loader({
    //   params: { collectionURL },
    //   password: payload.protected_password || null,
    //   verifiedMail: payload.private_mail || null,
    // })
    // let payload;
    // if (collectionData?.data?.visibility === "public") {
    //   payload = {
    //     collection_unique_url: collectionURL,
    //     uid: collectionData?.data?.uid,
    //     type: collectionData?.data?.visibility,
    //   };
    // } else if (collectionData?.data?.visibility === "protected") {
    //   payload = {
    //     collection_unique_url: collectionURL,
    //     uid: collectionData?.data?.uid,
    //     type: collectionData?.data?.visibility,
    //     password: e,
    //   };
    // } else if (collectionData?.data?.visibility === "private") {
    //   payload = {
    //     collection_unique_url: collectionURL,
    //     uid: collectionData?.data?.uid,
    //     type: collectionData?.data?.visibility,
    //     email: e,
    //   };
    // }

    // CollectionAuthentication(payload)
    //   .then((res) => {
    //     if (res?.data?.status === "success") {
    //       setIsPasswordFalse(false);
    //       setAuthPass(true);

    //       let authVerify = {
    //         id: collectionData?.data?.collectionID,
    //         pass: true,
    //       };
    //       sessionStorage.setItem("authVerify", JSON.stringify(authVerify));
    //       //  console.log("passed pas", collectionData?.data?.collectionID);
    //     } else if (res?.data?.status === "failed") {
    //       setIsPasswordFalse(true);
    //       setAuthPass(false);
    //     }
    //   })
    //   .catch((err) => {
    //     // console.log(err);
    //   });  
  };
  // console.log(features?.isLeadActive?.value,collectionID,collectionData?.data?.collectionID,(!(collectionID===collectionData?.data?.collectionID)),"leadactive");
  // if (collectionData?.data?.status === "failed") {
  //   return <Navigate to="/404" replace={true} />;
  // } else if (collectionData?.data?.visibility === "protected") {
  //   //  checkSessionStorageFn()
  //   // setIsPasswordFalse(true);
  //   //  setAuthPass(false);
  //   // return (
  //   //   <>
  //   //   {!authPass && <PasswordDialog
  //   //       passwordSubmitFN={passwordSubmitFN}
  //   //       isPasswordFalse={isPasswordFalse}
  //   //     />}
  //   //   </>
  //   // );
  // } else if (collectionData?.data?.visibility === "public") {
  //   //setAuthPass(true)
  // }

  // alert(collectionData?.data?.status);


  switch (collectionData?.response?.data?.status) {
    case "error":
      console.error("API Error:", collectionData.response.data);
      console.log("API Response:", collectionData?.response?.data);
      return <Navigate to="/404" replace />;

    case "failed":
      console.error("API Error:", collectionData.response.data);
      console.log("API Response:", collectionData?.response?.data);
      return <Navigate to="/500" replace />;

    default:
      break;
  }



  // Log the correct response
  return (
    <>
      {/* <PageLoader /> */}
      {/* {!authPass &&   <div class="spinner-border text-primary password-sec-spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>} */}
      <SessionTracker apiresponse={collectionData?.data} trackState={trackState} collectionURL={collectionURL} />
      {authPass !== true ? (
        <PasswordDialog
          passwordSubmitFN={passwordSubmitFN}
          isPasswordFalse={isPasswordFalse}
          visibility={visibility}
        />
      ) : null}

      {authPass && (
        <>
          {ChooseCollectionTemplate(
            collectionData?.data?.templateType,
            collectionData?.data?.templateName,
            collectionData?.data,
            setFeatures,
            {
              isContactUsFormEnabled:
                collectionData?.data?.settings?.isContactUsFormEnabled,
              isShareFormEnabled:
                collectionData?.data?.settings?.isShareFormEnabled,
              isSocialSharingButtonEnabled:
                collectionData?.data?.settings?.isSocialSharingButtonEnabled,
              isPoweredByLogoEnabled: collectionData?.data?.settings?.isPoweredByLogoEnabled,
            },
            trackState,
            collectionURL
          )}
          <ShareFeatureDesign />
          <ContactUsFeatureDesign />
          <LeadFeatureDesign />
          <FallbackSocial />
          <LocationTracker
            uid={collectionData?.data?.uid}
            source="collections"
            typeNumber={15}
            assetORCollectionID={collectionData?.data?.collectionID}
          />
        </>
      )}
    </>
  );
};

export function Loader({ params, password = null, verifiedMail = null }) {
  const { collectionURL } = params;

  let payload = {
    collection_unique_url: collectionURL,
  };

  if (password) {
    payload.protected_password = password;
  }

  if (verifiedMail) {
    payload.private_mail = verifiedMail;
  }

  return TemplateData(payload);
}
